import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";
import { api } from "../lib/api";

const PAGE_CSS = {
  card: "@page { size: 4in 6in; margin: 0; }",
  sheet: "@page { size: letter; margin: 0.25in; }",
};

function Card({ w, url, message }) {
  return (
    <div className="registry-card w-[4in] h-[6in] bg-[#FAF7F2] text-[#111] flex flex-col items-center justify-between text-center p-[0.4in] border border-[#C8A96B]/40" data-testid="registry-qr-card">
      <div>
        <p className="font-script text-[#C8A96B] text-3xl leading-none">Our registry</p>
        <p className="font-serif font-light text-[26px] mt-2 leading-tight">{w.couple_names}</p>
        {w.wedding_date && <p className="text-[10px] uppercase tracking-[0.3em] text-[#6b6b6b] mt-2">{new Date(w.wedding_date).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}</p>}
      </div>
      <div className="bg-white p-3 rounded-xl border border-[#C8A96B]/30"><QRCodeSVG value={url} size={150} fgColor="#111111" /></div>
      <div>
        <p className="font-serif italic text-[15px] leading-snug px-2">{message}</p>
        <p className="text-[9px] uppercase tracking-[0.25em] text-[#6b6b6b] mt-3">Scan to see our gifts & funds</p>
      </div>
    </div>
  );
}

export default function RegistryCardPrint() {
  const [w, setW] = useState(null);
  const [layout, setLayout] = useState("card");
  const [message, setMessage] = useState("Your presence is our greatest gift. If you'd like to give something more, scan below.");
  useEffect(() => { api.get("/weddings/mine").then((r) => setW(r.data)).catch(() => setW(false)); }, []);
  if (w === false) return <p className="p-10 text-center">Create your wedding first.</p>;
  if (!w) return null;
  const url = `${window.location.origin}/site/${w.slug}#registry`;
  return (
    <div className="min-h-screen bg-[#ece8e1] print:bg-white" data-testid="registry-print-page">
      <style>{`${PAGE_CSS[layout]} @media print { .no-print { display: none !important; } .registry-card { border: none; } }`}</style>
      <div className="no-print max-w-3xl mx-auto p-6 flex flex-wrap items-center gap-3">
        <h1 className="font-serif text-3xl flex-1">Registry QR card</h1>
        <div className="flex bg-white rounded-full p-1 text-xs">
          {[["card", "4x6 table card"], ["sheet", "Sheet of 4"]].map(([k, l]) => <button key={k} onClick={() => setLayout(k)} className={`px-4 py-2 rounded-full ${layout === k ? "bg-[#111] text-white" : ""}`} data-testid={`print-layout-${k}`}>{l}</button>)}
        </div>
        <button onClick={() => window.print()} className="btn-gold" data-testid="print-now-btn"><Printer className="w-4 h-4" /> Print</button>
        <textarea value={message} maxLength={140} onChange={(e) => setMessage(e.target.value)} rows={2} className="w-full rounded-xl p-3 text-sm bg-white outline-none" data-testid="print-message-input" />
      </div>
      <div className={`mx-auto pb-10 print:pb-0 ${layout === "sheet" ? "grid grid-cols-2 gap-[0.2in] w-[8in] [&_.registry-card]:w-[3.9in] [&_.registry-card]:h-[5.1in]" : "w-[4in]"}`}>
        {Array.from({ length: layout === "sheet" ? 4 : 1 }).map((_, i) => <Card key={i} w={w} url={url} message={message} />)}
      </div>
    </div>
  );
}
